module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ppelv0-84ae08b040e7d1dfa4c3a641d6231dfb.jpg";